import { useState, useCallback } from "react";
import { uploadData } from "aws-amplify/storage";
import { blobUrlToFile } from "../helper/createContent/blobUrlToFile";

const useUploadContentData = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const uploadPosterFiles = useCallback(async (item) => {
    setLoading(true);
    setError(null);
    try {
      if (item) {
        const file = item.posterFile;
        const uuid = item.posterFile.split("/").pop();
        const response = await blobUrlToFile(item.posterFile, uuid);
        const result = await uploadData({
          key: item.posterFile,
          data: response,
        }).result;
      }
    } catch (error) {
      setError(error);
      console.error("An error occurred during the upload process:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  return { uploadPosterFiles, loading, error };
};

export default useUploadContentData;
